export const checkinConclusion = [
  {
    path: '/conclusao-checkin',
    name: 'checkin-conclusion',
    component: () => import('@/views/conclusion/CheckinConclusion.view.vue'),
    meta: {
      isConclusionRoute: true,
    },
  },
  {
    path: '/informar-chegada',
    name: 'checkin-conclusion-simple',
    component: () => import('@/views/conclusion/CheckinConclusionSimple.view.vue'),
    meta: {
      isConclusionRoute: true,
    },
  },
  {
    path: '/conclusao-checkin-mobile',
    name: 'checkin-conclusion-mobile',
    component: () => import('@/views/conclusion/CheckinConclusionMobile.view.vue'),
    meta: {
      isConclusionRoute: true,
    },
  },
  {
    path: '/questionnaries',
    name: 'questionnaires',
    component: () => import('@/views/questionnaries/Questionnaries.view.vue'),
  },
  {
    path: '/exames-nao-agendados',
    name: 'unscheduled-exams',
    component: () => import('@/views/unscheduledExams/UnscheduledExams.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Exames não agendados',
        fixed: true,
      },
    },
  },
];
